'use strict';

angular.module('atex.dam').directive('damContextualMenu', function() {    
  return {
    restrict: 'EA',
    templateUrl : 'views/dam-contextual-menu.html',
    link: function (scope, element, attrs) {
    }
  };
});
